export function getEmailFromLocalStorage() {
    return localStorage.getItem("emailUsed");
}